import { useSnapshot } from 'valtio';
import { AppStore } from '../store/store';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { useStoreActions } from '../store/actions';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import cls from '../styles/Main.module.scss';

const Main = () => {
  const { toggleSelectedObject, onHoverOverObject } = useStoreActions()
  const { selectedObject } = useSnapshot(AppStore);

  const onNextPage = (selectedObject: 'М' | 'П') => {
    AppStore.selectedObject = selectedObject;
    AppStore.currentPage = selectedObject === 'М' ? 21 : 22;
  };

  return (
    <div className={cls.mainContainer}>
      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button className={cls.arrowButton} onClick={toggleSelectedObject}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Блок</p>
              <p>{selectedObject}</p>
            </div>
            <button className={cls.arrowButton} onClick={toggleSelectedObject}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.detailItem}>
            <div>Объект:</div>
            <div>«Seven»</div>
          </div>
          <div className={cls.detailItem}>
            <div>Этажей:</div>
            <div>14</div>
          </div>
          <div className={cls.detailItem}>
            <div>Количество квартир:</div>
            <div>120</div>
          </div>
          <div className={cls.detailItem}>
            <div>Адрес:</div>
            <div>Бишкек, мкрн Асанбай</div>
          </div>
        </div>

        <button onClick={() => onNextPage(selectedObject)} className={cls.selectButton}>
          Выбрать
        </button>
      </div>

      <div className={cls.imageContainer}>
        <svg viewBox="0 0 1180 837.33331">
          <path
            id="object_a"
            className={cls.objectA}
            onClick={() => onNextPage('М')}
            onMouseOver={() => onHoverOverObject('М')}
            fill="#3292ffcc"
            d="m 160.76086,556.38428v -2.80471 l 1.81668,-0.95616v -2.19914 l -4.14332,-2.13541v -6.72493 l 2.19915,-0.57369v -4.68514 l -6.46995,-4.90824v -2.99594 l 5.5138,-2.99594v -7.29862 l -8.12728,-5.03573v -4.65326 L 157,505.07084v -6.88429 l -8.15916,-5.19509v -4.97198 l 5.26508,-2.01564v -7.14413 l -8.00052,-6.19759v -3.78617 l 5.36373,-2.47904v -8.85692 l -8.06814,-5.11583v -3.98899 l 5.43135,-2.07338v -8.11321 l -8.09068,-6.10744v -4.32705 l 5.31866,-2.32128v -8.63155 l -7.88784,-5.5891v -4.39466 l 5.29612,-2.20859 v -8.20336l -8.09067,-5.31866 v -4.62002l 5.85954,-2.99739 v -8.24843l -8.76677,-5.29612 v -4.10168l 4.98061,-3.11006 v -10.36688l -7.34697,-5.00315 v -3.47065l 5.3412,-2.77201 v -9.96122l -7.45965,-5.47642 v -3.85377l 3.77172,-2.32342 V 308.5818 l -6.7568,-3.95209v -4.97198 l 4.58952,-2.9322v -9.81648 l -9.62525,-5.80065 v -13.25863l -1.84856,-1.27487 v -5.54567l -2.86845,-2.29477 -1.33861,-3.18717 129.39671,-46.04617 24.83543,15.95598 7.03145,-4.50734 51.63937,31.21913 v 7.7767l 6.11936,-3.95209 34.86764,22.75639 -5.54567,2.54974 34.61266,21.03532 14.9797,-6.50183 40.79578,23.45758 v 7.39423l 48.82745,29.13073 v 4.07958l -4.8445,2.99594 25.43361,15.48965 9.05157,-5.16322 13.83231,8.86034 7.64921,-4.27081 44.74787,26.26228 v 7.07552l -1.78482,0.4462 22.88389,14.27852 -7.26675,4.01584 34.82011,19.8568 -0.54088,4.77778 -5.31866,2.25366 v 13.97276l -1.08176,0.72117 v 8.38365l -10.34938,4.6304 -0.0637,6.62931 10.5814,6.27873 v 4.8445l -11.05948,5.19508 v 6.85242l 10.54954,6.69306 v 5.38631l -10.51766,4.55766 v 8.54161l 10.03958,5.64129 v 4.71702l -10.42204,6.1831 v 7.04365l 10.03958,5.22696 v 5.38632l -11.09135,5.89626 v 4.97199l 11.12322,6.88428 v 4.52579l -11.18696,6.08749 v 5.70503l 10.39017,6.97991 v 5.19508l -10.77263,5.25884 v 5.25883l 10.03958,6.43808 v 4.8445l -9.56151,5.19508 v 5.8644l 9.40215,6.18311 v 5.45006l -10.42204,5.45006 v 4.74888 l 9.9121,6.0875v 4.8445 l -10.7089,5.35444v 4.74888 l 9.72087,6.0875v 83.59947 l -73.98006,51.87447H 499.05263 L 160.88838,575.22045"
          />

          <path
            id="object_b"
            className={cls.objectB}
            onClick={() => onNextPage('П')}
            onMouseOver={() => onHoverOverObject('П')}
            fill="#3292ffcc"
            d="m 519.49337,375.46135v -16.38418 l -5.76939,-3.53826v -3.06499 l 5.45388,-2.81709v -8.78931 L 513.431,336.9236v -3.1326 l 5.25105,-2.4565v -9.1499 l -5.45388,-3.22275v -3.26782 l 5.09329,-2.20859v -9.84854 l -5.02568,-2.92977v -3.35797 l 5.67925,-2.47904v -9.19497 l -6.82862,-3.33543v -3.40304 l 6.15251,-2.59172v -8.02306 l -11.71908,-6.51311 v -2.38889l 10.20913,-4.68763 v -7.41457l -4.55242,-2.59172 v -4.14676l 4.64256,-1.91561 v -10.20913l -6.28774,-3.1326 v -4.07914l 6.24267,-2.4565 v -9.69078l -6.4455,-3.22275 v -4.12421l 6.15252,-2.2086 v -9.66824l -6.40042,-3.94392 v -3.62841l 4.81042,-2.41545 v -12.58932l -7.74482,-4.1752 v -3.56963 l -1.21112,-0.38246 v -18.31292l 93.52605,-34.25578 21.22957,10.59225 10.72747,-6.58072 68.87214,33.80504 -0.13522,5.0933 -4.28197,2.29874 196.44258,88.25047 9.08344,-5.57755 62.7508,29.06402 2.16352,-1.57757 27.58492,12.07967 v 4.59748l -8.56394,4.55242 33.80502,14.78407 v 4.0566l -4.8003,2.27621 v 17.60116l -14.94183,6.49057 v 8.74424l 8.92453,2.79455 v 5.5891l -11.94506,5.56603 v 6.94803l 7.90416,3.18717 v 6.18311l -10.45389,5.09948 v 6.7568l 8.03169,3.12342 v 6.82055l -10.07148,4.71701 v 6.31059l 7.64921,3.18717 v 6.18311l -9.56151,4.97199 v 5.22648l 12.58738,4.4172 v 5.22851l -15.68558,8.20336 v 4.2369l 7.84277,3.33543 v 5.04822l -10.9979,5.5891 v 5.04822l 8.20335,4.14675 v 5.5891l -10.18658,5.49895 v 4.86793 l 7.48218,3.87631v 5.76939 l -10.45703,5.67925v 4.32705 l 7.93292,4.68763v 5.40881 l -8.83438,4.59748v 4.50734 l 7.30188,4.86793v 4.77778 l -9.73585,5.49895v 4.2369 l 8.11321,5.31866 v 4.59749l -9.01468,5.49895 v 4.59749l -3.60587,1.80293 v 11.26835L 894.61666,620.20986 640.1431,470.71314 v -13.91686l 5.30786,-2.23113 0.54088,-4.82285 -34.81214,-19.84884 7.25389,-4.02627 -22.875,-14.27344 1.78516,-0.44531 v -7.08594l -44.75085,-26.26308 -7.64559,4.27579 -13.83794,-8.85646 -9.05468,5.16016 -2.57032,-1.57422 z"
          />

          <circle className={cls.symbolsA} cx="350" cy="235" r="40" fill="#333333" />
          <text className={cls.symbolsA} x="350" y="225" fontSize="14" textAnchor="middle" fill="white">Блок</text>
          <text className={cls.symbolsA} x="350" y="255" fontSize="24" textAnchor="middle" fill="white">М</text>

          <circle className={cls.symbolsB} cx="800" cy="160" r="40" fill="#333333" />
          <text className={cls.symbolsB} x="800" y="150" fontSize="14" textAnchor="middle" fill="white">Блок</text>
          <text className={cls.symbolsB} x="800" y="180" fontSize="24" textAnchor="middle" fill="white">П</text>
        </svg>
        <LazyLoadImage
          src="./images/structure.png"
          alt=""
          effect="blur"
          placeholderSrc='./images/placeholder/structure.png'
        />
      </div>
    </div>
  );
};

export default Main;
